import { createReducer, on } from '@ngrx/store';
import {
  changePageInfo,
  changeDateOption,
  resetOption,
  notificationToggle,
  getHelp,
  getHelpSuccess,
  getHelpFailure,
  fetchUserTypes,
  fetchUserTypesSuccess,
  fetchUserTypesFaild,
  getCommissions,
  getCommissionsSuccess,
  getCommissionsFailure
 } from './page.actions';

import { PageState } from '@models/index';

const initialState: PageState = {
  breadcrum: ['Affiliate Partner'],
  pageURL: '',
  datePickerOptions: {
    dateFormat: 'yyyy-mm-dd',
    height: '36px',
    inline: false
  },
  language: '',
  notification: {
    show: false,
    error: false,
    message: ''
  },
  help: {
    error: null
  },
  userTypes: {
    isLoaded: false,
    data: [],
    selectedItem: {},
    error: null,
    total: 0,
    maxPages: 0,
    perPage: 0,
    currentPage: 0
  },
  commissions: {
    error: null,
    isLoaded: false,
    isLoading: false,
    data: {}
  }
};

const _pageReducer = createReducer(
  initialState,
  on(changePageInfo , (state , { page }) => { return { ...state, ...page } }),
  on(changeDateOption, (state , { option }) => {
    const payload = {
      datePickerOptions: { ...state.datePickerOptions, ...option }
    }

    return { ...state, ...payload };
  }),
  on(resetOption, (state , { optionName }) => {
    const payload = {
      datePickerOptions: { ...state.datePickerOptions, [optionName]: { year: 0, month: 0, day: 0 } }
    }

    return { ...state, ...payload };
  }),
  on(notificationToggle, (state , { option }) => {
    const payload = {
      notification: { ...option }
    }

    return { ...state, ...payload };
  }),
  on(getHelp, (state, { key }) => {
    const payload = {
      help: {
        ...state.help,
        error: null
      }
    };
    return { ...state, ...payload };
  }),
  on(getHelpSuccess, (state, { help }) => {
    const payload = {
      help: {
        ...state.help,
        [help.key] : help.text
      }
    };
    return { ...state, ...payload };
  }),
  on(getHelpFailure, (state, { error }) => {
    const payload = {
      help: {
        ...state.help,
        error
      }
    };
    return { ...state, ...payload };
  }),
  on(fetchUserTypes, (state) => {
    const payload = {
      userTypes: {
        ...state.userTypes,
        data: [],
        isLoaded: false,
        error: null,
        selectedItem: {}
      }
    };
    return { ...state, ...payload };
  }),
  on(fetchUserTypesSuccess, (state, { userTypes }) => {
    const payload = {
      userTypes: {
        ...state.userTypes,
        isLoaded: true,
        data: userTypes.data,
        total: userTypes.total,
        maxPages: userTypes.maxPages,
        perPage: userTypes.perPage,
        currentPage: userTypes.currentPage
      }
    };
    return { ...state, ...payload };
  }),
  on(fetchUserTypesFaild, (state, { error }) => {
    const payload = {
      userTypes: {
        ...state.userTypes,
        error
      }
    };
    return { ...state, ...payload };
  }),
  on(getCommissions, (state) => {
    const payload = {
      commissions: {
        ...state.commissions,
        isLoading: true, //
      }
    };

    return {  ...state, ...payload  };
  }),
  on(getCommissionsSuccess, (state , data ) => {
    const payload = {
      commissions: {
        data: {...data.payload},
        isLoaded: true,
        isLoading: false,
        error: null
      }
    };

    return { ...state, ...payload };
  }),
  on(getCommissionsFailure, (state , error) => {
    const payload = {
      commissions: {
        data: {},
        error,
        isLoaded: false,
        isLoading: false,
      }
    };

    return { ...state, ...payload };
  })
);


export function pageReducer(state, action) {
  return _pageReducer(state, action);
}
